import { render, staticRenderFns } from "./DefalutLayout.vue?vue&type=template&id=3a8bb73f&"
import script from "./DefalutLayout.vue?vue&type=script&lang=js&"
export * from "./DefalutLayout.vue?vue&type=script&lang=js&"
import style0 from "./DefalutLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports